import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Services from "./components/pages/Services";
import ContactUs from "./components/pages/Contact";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import FAQ from "./components/pages/FAQ";
import Footer from "./components/Footer";
import CallBanner from "./components/CallBanner";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        {/* Bottom padding on mobile keeps the footer clear of the call banner */}
        <div className="App pb-14 lg:pb-0">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
          <Footer />
          <CallBanner />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
